import Splide from '@splidejs/splide';
// https://splidejs.com/options/

const carouselInit = () => {
    const carousels = document.getElementsByClassName('splide');

    if (carousels.length) {
        carousels.forEach((carousel) => {
            const { autoplay, speed } = carousel.dataset;

            const splideCarousel = new Splide(carousel, {
                type: 'loop',
                perPage: 3,
                focus: 'center',
                autoplay,
                interval: autoplay && (speed * 1000 || 6000),
                flickMaxPages: 3,
                updateOnMove: true,
                pagination: false,
                padding: '10%',
                throttle: 300,
                breakpoints: {
                    1440: {
                        perPage: 1,
                        padding: '30%'
                    }
                }
            }).mount();

            return splideCarousel;
        });
    }
};

export { carouselInit };
